import {EndpointEnum} from '../../constants/EndpointEnum';
import HttpErrorResponseModel from '../../models/HttpErrorResponseModel';
import IStore from '../../models/IStore';
import * as EffectUtility from '../../utilities/EffectUtility';
import UserImportResponse from '../models/UserImportResponse';
import UserModel from '../models/UserModel';

export default class UserEffect {
    public static async getUserList(state: IStore): Promise<UserModel | HttpErrorResponseModel> {
        return await EffectUtility.getToModel(state, UserModel, EndpointEnum.userList);
    }

    public static async getUserAdminList(state: IStore): Promise<UserModel | HttpErrorResponseModel> {
        return await EffectUtility.getToModel(state, UserModel, EndpointEnum.adminUserList);
    }

    public static async updateOwnUser(state: IStore, idToken: string): Promise<UserModel | HttpErrorResponseModel> {
        return await EffectUtility.putToModel(state, UserModel, EndpointEnum.ownUserUpdate, {idToken: idToken});
    }

    public static async createUser(state: IStore, model: any): Promise<UserModel | HttpErrorResponseModel> {
        return await EffectUtility.postToModel(state, UserModel, EndpointEnum.userCreate, model);
    }

    public static async getUser(state: IStore, userId: string): Promise<UserModel | HttpErrorResponseModel> {
        return await EffectUtility.getToModel(state, UserModel, EndpointEnum.userGet.replace(':userId', userId));
    }

    public static async deleteUser(state: IStore, userId: string): Promise<String | HttpErrorResponseModel> {
        return await EffectUtility.deleteToModel(state, String, EndpointEnum.userDelete.replace(':userId', userId));
    }

    public static async updateUser(state: IStore, userId: string, userData: any): Promise<String | HttpErrorResponseModel> {
        return EffectUtility.putToModel<String>(state, String, EndpointEnum.userPut.replace(':userId', userId), userData);
    }

    public static async exportUserList(state: IStore): Promise<any> {
        return EffectUtility.getToModel<Object>(state, Object, EndpointEnum.userListExport);
    }

    public static async importUserList(state: IStore, csvFile:File ):Promise<UserImportResponse | HttpErrorResponseModel>{
        const formData = new FormData();
        formData.append('file', csvFile);
        return await EffectUtility.postToModel<UserImportResponse>(state, UserImportResponse, EndpointEnum.userListImport, formData);
    }

    public static async checkUserInitialSetup(state: IStore): Promise<UserModel | HttpErrorResponseModel> {
        return await EffectUtility.getToModel(state, UserModel, EndpointEnum.checkUserInitialSetup);
    }
}